import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

const PUBLIC = process.env.PUBLIC_URL || "";

const ORBIT_CARDS = [
  {
    label: "AVERLYNXSTORE MOVEMENT CLUB",
    src: `${PUBLIC}/img/101-averlynxstore.png`,
    style: { top: "10%", left: "10%", width: "15%", aspectRatio: "4 / 3" },
  },
  {
    label: "COMMUNITY SUPPORT",
    src: `${PUBLIC}/img/102-averlynxstore.png`,
    style: { top: "30%", left: "6%", width: "13%", aspectRatio: "1 / 1" },
  },
  {
    label: "COMMUNITY EVENTS",
    src: `${PUBLIC}/img/103-averlynxstore.png`,
    style: { top: "46%", left: "12%", width: "16%", aspectRatio: "5 / 3" },
  },
  {
    label: "PRO PROGRAM",
    src: `${PUBLIC}/img/104-averlynxstore.png`,
    style: { top: "66%", left: "8%", width: "17%", aspectRatio: "5 / 3" },
  },
  {
    label: "DIGITAL STUDIO",
    src: `${PUBLIC}/img/105-averlynxstore.png`,
    style: { top: "78%", left: "26%", width: "15%", aspectRatio: "16 / 10" },
  },
  {
    label: "WELLNESS SYSTEM",
    src: `${PUBLIC}/img/106-averlynxstore.png`,
    style: { top: "76%", left: "46%", width: "14%", aspectRatio: "4 / 3" },
  },
  {
    label: "ATELIER",
    src: `${PUBLIC}/img/107-averlynxstore.png`,
    anchor: "right",
    style: { top: "70%", right: "10%", width: "12%", aspectRatio: "3 / 4" },
  },
  {
    label: "ACCESSORIES",
    src: `${PUBLIC}/img/1014-averlynxstore.png`,
    anchor: "right",
    style: { top: "42%", right: "8%", width: "12%", aspectRatio: "3 / 4" },
  },
  {
    label: "FOOTWEAR",
    src: `${PUBLIC}/img/1017-averlynxstore.png`,
    anchor: "right",
    style: { top: "26%", right: "10%", width: "16%", aspectRatio: "5 / 3" },
  },
  {
    label: "APPAREL",
    src: `${PUBLIC}/img/1011-averlynxstore.png`,
    anchor: "right",
    style: { top: "12%", right: "12%", width: "12%", aspectRatio: "3 / 4" },
  },
  {
    label: "REST & RECOVERY",
    src: `${PUBLIC}/img/1020-averlynxstore.png`,
    style: { top: "6%", left: "44%", width: "14%", aspectRatio: "3 / 4" },
  },
];

function About() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="about">
      <Header />

      <section className="about-orbit" aria-label="Welcome to averlynxstore">
        <div className="about-orbit__stage">
          {ORBIT_CARDS.map((card) => (
            <Link
              onClick={toTop}
              key={card.label}
              to="/shop"
              className={`about-orbit__card${
                card.anchor === "right"
                  ? " about-orbit__card--anchor-right"
                  : ""
              }`}
              style={card.style}
            >
              {(() => {
                const isVideo = card.src.toLowerCase().endsWith(".mp4");
                return isVideo ? (
                  <video
                    src={card.src}
                    className="about-orbit__card-video"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                ) : (
                  <img
                    src={card.src}
                    alt=""
                    className="about-orbit__card-img"
                  />
                );
              })()}
              <span className="about-orbit__card-label">{card.label}</span>
            </Link>
          ))}
          <div className="about-orbit__center">
            <p className="about-orbit__eyebrow">WELCOME TO</p>
            <h1 className="about-orbit__title">AVERLYNXSTORE:</h1>
            <p className="about-orbit__tagline">
              considered essentials for everyday movement
            </p>
          </div>
        </div>
      </section>

      <section
        className="about-philosophy"
        style={{
          backgroundImage: `url(${PUBLIC}/main/averlynxstore-travel.png)`,
        }}
      >
        <div className="about-philosophy__inner">
          <p className="about-philosophy__kicker">OUR PHILOSOPHY</p>
          <p className="about-philosophy__body">
            We create comfortable, versatile pieces that support training,
            recovery, travel, and the movement woven into everyday life.
          </p>
        </div>
      </section>

      <section className="about-banner" aria-hidden="true">
        <img
          src={`${PUBLIC}/main/averlynxstore-movement.png`}
          alt=""
          className="about-banner__img"
        />
      </section>

      <section className="about-sourcing">
        <img
          src={`${PUBLIC}/img/1015c-averlynxstore.png`}
          alt=""
          className="about-sourcing__img about-sourcing__img--top"
        />
        <h2 className="about-sourcing__heading">RESPONSIBLE SOURCING</h2>
        <img
          src={`${PUBLIC}/main/averlynxstore-hero.png`}
          alt=""
          className="about-sourcing__img about-sourcing__img--bottom"
        />
      </section>

      <section className="about-commitment" id="commitment">
        <div className="about-commitment__inner">
          <div className="about-commitment__titles">
            <h2 className="about-commitment__title">averlynxstore COMMITMENT</h2>
            <p className="about-commitment__subtitle">TO WORKPLACE STANDARDS</p>
            <h2 className="about-commitment__title about-commitment__title--bottom">
              RESPONSIBLE MANUFACTURING
            </h2>
          </div>
          <div className="about-commitment__body">
            <p>
              We build our products on an ethical foundation that honors human
              rights through every step of the process. As long-time supporters
              of ethical working conditions, averlynxstore asks suppliers to respect
              fair-pay, workplace-safety, non-discrimination, and freely chosen
              employment principles throughout production.
            </p>
            <div className="about-fla" aria-label="averlynxstore supplier standards">
              <span className="about-fla__mark" aria-hidden />
              <span className="about-fla__text">
                Supplier
                <br />
                Standards
              </span>
            </div>
            <p>
              This approach reflects both our values and our long-term vision.
              Our supplier review process is designed to strengthen how these
              expectations are communicated and monitored. This includes:
            </p>
            <ul className="about-commitment__list">
              <li>
                Strengthening our social compliance program to align with
                globally respected standards;
              </li>
              <li>
                Ensuring independent monitoring of our supply chain to identify
                and address risks;
              </li>
              <li>
                Building management systems for remediation, worker empowerment,
                and training;
              </li>
              <li>
                Improving documentation and follow-up when concerns are found
              </li>
            </ul>
            <p>
              To reinforce this commitment, we are investing in a dedicated
              Social Compliance team to lead and implement these programs. Our
              team regularly engages subject matter experts, civil society
              organizations, and other stakeholders to gather guidance and
              feedback on our initiatives. Our Social Compliance team can be
              reached at:{" "}
              <a href="mailto:cost@averlynxstore.one">cost@averlynxstore.one</a>.
            </p>
            <button
              type="button"
              className="about-to-top"
              onClick={toTop}
              aria-label="Back to top"
            >
              ↑
            </button>
          </div>
        </div>
      </section>

      <section className="about-mfg">
        <div className="about-mfg__split">
          <div className="about-mfg__text">
            <h2 className="about-mfg__heading">
              RESPONSIBLE
              <br />
              MANUFACTURING
            </h2>
            <p>
              We are committed to the fair treatment of workers throughout our
              entire supply chain. Our supplier expectations address issues
              around recruitment fees, labor abuse, unsafe working conditions,
              extended hours and inadequate pay scales. We are working with our
              global supply chain partners to create conditions so that:
            </p>
            <ul className="about-mfg__list">
              <li>No workers pay for their job;</li>
              <li>
                Workers receive a timely refund of fees and costs paid to obtain
                or maintain their job;
              </li>
              <li>
                Workers retain control of their travel documents and have full
                freedom of movement; and
              </li>
              <li>
                All workers are informed, in a language they understand, of the
                basic terms of their employment before leaving their country of
                origin
              </li>
            </ul>
          </div>
          <div className="about-mfg__media">
            <img
              src={`${PUBLIC}/img/1013c-averlynxstore.png`}
              alt=""
              className="about-mfg__img"
            />
          </div>
        </div>
        <div className="about-mfg__standards">
          <h2 className="about-mfg__heading about-mfg__heading--narrow">
            WORKPLACE
            <br />
            STANDARDS
          </h2>
          <p className="about-mfg__standards-copy">
            Our Workplace Standards specifies basic minimum policies,
            procedures, and working conditions that our owned operations and our
            suppliers must meet to do business with us.
          </p>
        </div>
        <button
          type="button"
          className="about-to-top about-to-top--section"
          onClick={toTop}
          aria-label="Back to top"
        >
          ↑
        </button>
      </section>

      <Footer />
    </div>
  );
}

export default About;
